import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import LocationUtil from './location_util';

export default class Pagination extends React.Component {
  static get propTypes() {
    return {
      page: PropTypes.number.isRequired,
      paginationPathname: PropTypes.string.isRequired,
      changePage: PropTypes.func.isRequired,
      children: PropTypes.node,
      rel: PropTypes.string,
      window: PropTypes.object.isRequired,
    };
  }

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(evt) {
    this.props.changePage(this.props.page, evt);
  }

  pageHref() {
    const origQueryString = this.props.window.location.search.replace(/\?/, '');
    const queryObject = LocationUtil.queryWithPage(qs.parse(origQueryString), this.props.page);
    const queryString = qs.stringify(queryObject);

    return `${this.props.paginationPathname}?${queryString}`;
  }

  render() {
    return (
      <a
        href={this.pageHref()}
        rel={this.props.rel}
        onClick={this.onClick}
      >
        {this.props.children}
      </a>
    );
  }
}
